import React, { useState, useEffect } from 'react';
import { LayoutGrid, ArrowRight, PanelLeft, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/Footer';
import { getLibrary, LibraryRow } from '../services/libraryService';
import { getDashboard } from '../services/userService';
import { UPLOAD_BASE_URL } from '../services/api';
import { UserLiveClassesSection } from '../component/UserLiveClassesSection';

type CourseCard = {
  id: string;
  title: string;
  category: string;
  image: string;
  description?: string;
  link?: string;
  plan_ids?: number[];
};

type CategoryItem = {
  value: string;
  title: string;
  icon: React.ComponentType<{ className?: string }>;
};

const THUMBNAIL_CACHE_BUSTER = Date.now();

const withThumbnailTimestamp = (url: string): string =>
  `${url}${url.includes('?') ? '&' : '?'}${THUMBNAIL_CACHE_BUSTER}`;

export function canOpenContent(planIds?: number[], userPlanId?: number | null): boolean {
  if (!planIds || planIds.length === 0) {
    return true;
  }
  return userPlanId !== null && userPlanId !== undefined && planIds.includes(userPlanId);
}

const courseRows: CourseCard[] = [
  // --- How to Make Viral Quiz Videos on TikTok and Shorts (10 items) ---
  {
    id: 'vq-1',
    title: 'Find a viral quiz niche on tiktok',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/1.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/1.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-3',
    title: 'Make a voice over using ElevenLabs',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/2.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/2.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-4',
    title: 'Find quiz topics on Quora',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/3.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/3.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-5',
    title: 'Make a quiz using Gemini',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/4.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/4.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-6',
    title: 'How to find viral backsounds on TikTok',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/5.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/5.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-7',
    title: 'How to find viral backsounds on Youtube Shorts',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/6.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/6.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-8',
    title: 'Download audio backsounds on TikTok and YouTube',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/7.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/7.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-9',
    title: 'Make quiz images using Leonardo AI',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/8.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/8.mp4`,
    plan_ids: [],
  },
  {
    id: 'vq-10',
    title: 'How to make quiz images using Ideogram AI',
    category: 'How to Make Viral Quiz Videos on TikTok and Shorts',
    image: `${UPLOAD_BASE_URL}/1/module1/9.webp`,
    link: `${UPLOAD_BASE_URL}/1/module1/9.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-1',
    title: "Find ideas for a children's story youtube channel",
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/1.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/1.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-2',
    title: 'Find ideas for a tiktok account',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/2.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/2.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-3',
    title: 'How to take a transcript from a youtube channel',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/3.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/3.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-4',
    title: 'How to rewrite a transcript in ChatGPT',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/4.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/4.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-5',
    title: 'How to make a voice over using elevenlab',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/5.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/5.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-6',
    title: "How to make a picture of childern's story Leonardo",
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/6.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/6.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-7',
    title: "How to edit childern's story videos in capcut",
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/7.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/7.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-8',
    title: 'How to make automatic captions in capcut',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/8.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/8.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-9',
    title: 'How to make captions in Clipchamp',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/9.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/9.mp4`,
    plan_ids: [],
  },
  {
    id: 'cs-10',
    title: 'How to export videos in clipchamp',
    category: "How to Create children's story videos with AI",
    image: `${UPLOAD_BASE_URL}/1/module3/10.webp`,
    link: `${UPLOAD_BASE_URL}/1/module3/10.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-1',
    title: 'Find examples of fantasy niche videos with AI',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/1.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/1.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-2',
    title: 'Register at Morphstudio',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/2.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/2.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-3',
    title: 'Find prompt ideas in ChatGPT for fantasy video',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/3.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/3.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-4',
    title: 'Create an interesting AI image for a video scene',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/4.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/4.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-5',
    title: 'Create a video with a prompt using morphstudio',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/5.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/5.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-6',
    title: 'Create a video with existing images using morphstudio',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/6.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/6.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-7',
    title: 'How to use batch upload to morphstudio',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/7.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/7.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-8',
    title: 'How to change video style in morphstudio',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/8.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/8.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-9',
    title: 'How to use the motionbrush feature',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/9.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/9.mp4`,
    plan_ids: [],
  },
  {
    id: 'fn-10',
    title: 'How to export files in morphstudio',
    category: 'How to make fantasy niche Videos with AI',
    image: `${UPLOAD_BASE_URL}/1/module2/10.webp`,
    link: `${UPLOAD_BASE_URL}/1/module2/10.mp4`,
    plan_ids: [],
  },
  // --- AI for productivity (10 items) ---
  {
    id: 'ap-1',
    title: '5 AI tips and tricks you can learn right now',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/1.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/1.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-2',
    title: 'Pros and cons of content creation using AI tools',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/2.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/2.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-3',
    title: "5 Reasons Why AI Isn't All That Bad When it Comes to Task Management",
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/3.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/3.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-4',
    title: '5 Reasons Why Your Workflow Will Be Easier with AI',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/4.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/4.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-5',
    title: '5 Tips That Will Help You Stay On Top Of Your Schedule With AI',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/5.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/5.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-6',
    title: " 5 Tips To Make AI Your Best Co-Pilot During Challenging Work Projects",
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/6.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/6.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-7',
    title: 'Can AI Help With Team Projects? The Answer Might Surprise You',
  
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/7.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/7.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-8',
    title: 'How To Improve Your Time Management: 5 Ways AI Can Help',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/8.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/8.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-9',
    title: 'How To Master the AI Basics',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/9.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/9.mp4`,
    plan_ids: [],
  },
  {
    id: 'ap-10',
    title: 'Is AI Great for Communication Between Team Members?',
    category: 'AI for productivity',
    image: `${UPLOAD_BASE_URL}/1/module4/10.webp`,
    link: `${UPLOAD_BASE_URL}/1/module4/10.mp4`,
    plan_ids: [],
  },
  // --- artificial-intelligence-in-digital-marketing (10 items) ---
  {
    id: 'dm-1',
    title: 'What Is AI And Machine Learning?',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/1.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/1.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-2',
    title: 'Google As An AI-First Company',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/2.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/2.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-3',
    title: 'Preparing For Semantic Search',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/3.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/3.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-4',
    title: 'Big Data',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/4.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/4.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-5',
    title: 'Computer Version',
    
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/5.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/5.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-6',
    title: 'Advertising',
    
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/6.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/6.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-7',
    title: 'Email Marketing',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/7.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/7.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-8',
    title: 'Chatbots',
    
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/8.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/8.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-9',
    title: 'Developing Your AI Skills – Using SQL',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/9.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/9.mp4`,
    plan_ids: [],
  },
  {
    id: 'dm-10',
    title: 'How To Future Proof Your Marketing',
    category: 'Artificial Intelligence in Digital Marketing',
    image: `${UPLOAD_BASE_URL}/1/module5/10.webp`,
    link: `${UPLOAD_BASE_URL}/1/module5/10.mp4`,
    plan_ids: [],
  },
];

const mapLibraryRowsToCourses = (rows: LibraryRow[]): CourseCard[] =>
  rows.flatMap((row, rowIndex) =>
    row.cards.map((card, cardIndex) => ({
      id: `dynamic-${rowIndex}-${cardIndex}-${card.title}`,
      title: card.title,
      category: row.title,
      image: card.image,
      description: card.title,
      link: card.link,
      plan_ids: card.plan_ids,
    })),
  );

const Library = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(courseRows[0]?.category ?? '');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [courses, setCourses] = useState<CourseCard[]>(courseRows);
  const [userPlanId, setUserPlanId] = useState<number | null>(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [activeSection, setActiveSection] = useState<'library' | 'live-classes'>('library');

  const categories: CategoryItem[] = [
    { value: 'All', title: 'All Courses', icon: LayoutGrid },
    ...courses.reduce<CategoryItem[]>((items, course) => {
      const exists = items.some((item) => item.value === course.category);
      return exists
        ? items
        : [...items, { value: course.category, title: course.category, icon: LayoutGrid }];
    }, []),
  ];

  const filteredCourses =
    activeCategory === 'All' ? courses : courses.filter((course) => course.category === activeCategory);

  const activeCategoryObj = categories.find((cat) => cat.value === activeCategory);
  const activeTitle = activeCategoryObj ? activeCategoryObj.title : 'All Courses';

  useEffect(() => {
    let isMounted = true;

    const loadLibrary = async () => {
      try {
        const rows = await getLibrary();
        const dynamicCourses = mapLibraryRowsToCourses(rows || []);

        if (isMounted && dynamicCourses.length > 0) {
          setCourses(dynamicCourses);
        }
      } catch {
        if (isMounted) {
          setCourses(courseRows);
        }
      }
    };

    loadLibrary();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const token = localStorage.getItem('token');

    if (!token) {
      setUserPlanId(null);
      return () => {
        isMounted = false;
      };
    }

    const loadDashboard = async () => {
      try {
        const response = await getDashboard(token);
        if (isMounted) {
          setUserPlanId(response.data.plan_id ?? null);
        }
      } catch {
        if (isMounted) {
          setUserPlanId(null);
        }
      }
    };

    loadDashboard();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (isSidebarOpen || showUpgradeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSidebarOpen, showUpgradeModal]);

  const handleOpenContent = (course: CourseCard) => {
    if (!canOpenContent(course.plan_ids, userPlanId)) {
      setShowUpgradeModal(true);
      return;
    }

    if (course.link) {
      window.open(course.link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <>
      <Header />
      <div className="bg-[#fcfaf8] min-h-screen font-sans text-zinc-900">
        <div className="pt-24 pb-12 px-6 border-b border-zinc-200 bg-white">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-black text-zinc-900 tracking-tight">
              Welcome back, <span className="text-amber-500">User</span>
            </h1>
            <p className="text-zinc-500 mt-2 font-medium">Continue your path to AI mastery.</p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 py-12 relative">
          <div className="mb-8 inline-flex rounded-xl border border-zinc-200 bg-white p-1 shadow-sm">
            <button type="button" onClick={() => setActiveSection('library')} className={`rounded-lg px-5 py-2.5 text-xs font-black uppercase tracking-widest transition-colors ${activeSection === 'library' ? 'bg-zinc-950 text-white' : 'text-zinc-500 hover:text-zinc-950'}`}>Library</button>
            <button type="button" onClick={() => setActiveSection('live-classes')} className={`rounded-lg px-5 py-2.5 text-xs font-black uppercase tracking-widest transition-colors ${activeSection === 'live-classes' ? 'bg-zinc-950 text-white' : 'text-zinc-500 hover:text-zinc-950'}`}>Live Classes</button>
          </div>

          {activeSection === 'live-classes' ? (
            <UserLiveClassesSection token={localStorage.getItem('token')} />
          ) : (
            <>
          <div className="lg:hidden mb-8">
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="w-full flex items-center justify-between bg-white border border-zinc-200 p-4 rounded-2xl shadow-sm hover:border-amber-400 transition-colors"
            >
              <div className="flex items-center gap-3 shrink-0">
                <PanelLeft className="w-5 h-5 text-zinc-500" />
                <span className="font-bold text-zinc-900">Sidebar</span>
              </div>
              <div className="bg-zinc-100 px-3 py-1 rounded-lg text-sm font-bold truncate max-w-[140px] sm:max-w-[250px]">
                {activeTitle}
              </div>
            </button>
          </div>

          <div className="flex flex-col lg:flex-row gap-12">
            {isSidebarOpen && (
              <div
                className="fixed inset-0 bg-zinc-950/60 backdrop-blur-sm z-40 lg:hidden transition-opacity"
                onClick={() => setIsSidebarOpen(false)}
              />
            )}

            <aside
              className={`fixed inset-y-0 left-0 z-50 w-[300px] h-full overflow-y-auto bg-[#fcfaf8] transform transition-transform duration-300 ease-in-out lg:bg-transparent lg:relative lg:translate-x-0 lg:z-auto lg:h-auto lg:overflow-visible lg:w-[280px] lg:shrink-0 ${
                isSidebarOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'
              }`}
            >
              <div className="p-6 lg:p-0 lg:sticky lg:top-8 space-y-6">
                <div className="flex items-center justify-between lg:hidden mb-2">
                  <h2 className="font-black text-xl text-zinc-900 tracking-tight">Categories</h2>
                  <button
                    onClick={() => setIsSidebarOpen(false)}
                    className="p-2 bg-white border border-zinc-200 rounded-full hover:bg-zinc-100 transition-colors"
                  >
                    <X className="w-5 h-5 text-zinc-500" />
                  </button>
                </div>

                <div className="bg-white border border-zinc-200 rounded-[2rem] p-6 shadow-xl shadow-zinc-200/40">
                  <h3 className="hidden lg:block text-xs font-black uppercase tracking-widest text-zinc-400 mb-6 px-2">
                    Categories
                  </h3>

                  <nav className="flex flex-col gap-2">
                    {categories.filter((cat) => cat.value !== 'All').map((cat) => {
                      const Icon = cat.icon;
                      const isActive = activeCategory === cat.value;

                      return (
                        <button
                          key={cat.value}
                          onClick={() => {
                            setActiveCategory(cat.value);
                            setIsSidebarOpen(false);
                          }}
                          className={`group flex items-center justify-between px-4 py-3.5 rounded-xl font-bold text-sm transition-all duration-300 ${
                            isActive
                              ? 'bg-[#09090B] text-white shadow-md translate-x-1'
                              : 'text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900 hover:translate-x-1 border border-transparent hover:border-zinc-200'
                          }`}
                        >
                          <div className="flex items-center gap-3 text-left">
                            <Icon
                              className={`w-4 h-4 shrink-0 transition-colors duration-300 ${
                                isActive ? 'text-white' : 'text-zinc-400 group-hover:text-[#09090B]'
                              }`}
                            />
                            {cat.title}
                          </div>
                          <ArrowRight
                            className={`w-4 h-4 transition-all duration-300 shrink-0 ${
                              isActive
                                ? 'opacity-100 translate-x-0 text-white'
                                : 'opacity-0 -translate-x-4 text-[#09090B] group-hover:opacity-100 group-hover:translate-x-0'
                            }`}
                          />
                        </button>
                      );
                    })}
                  </nav>
                </div>
              </div>
            </aside>

            <main className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-8">
                <h2 className="text-xl font-bold text-zinc-900">
                  {activeTitle}{' '}
                  <span className="text-zinc-400 font-medium ml-2 text-sm">
                    ({filteredCourses.length} {filteredCourses.length === 1 ? 'course' : 'courses'})
                  </span>
                </h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {filteredCourses.map((course) => (
                  <button
                    type="button"
                    key={course.id}
                    onClick={() => handleOpenContent(course)}
                    className="text-left bg-white border border-zinc-200 rounded-[2rem] overflow-hidden hover:border-amber-400 hover:shadow-2xl hover:shadow-amber-500/10 transition-all duration-500 group flex flex-col h-full"
                  >
                    <div className="h-52 md:h-44 lg:h-52 relative overflow-hidden shrink-0">
                      <img
                        src={withThumbnailTimestamp(course.image)}
                        alt={course.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      />
                    </div>

                    <div className="p-6 flex flex-col flex-1">
                      <h3 className="text-base font-black text-zinc-900 mb-2 leading-tight">
                        {course.title}
                      </h3>
                      <p className="text-sm text-zinc-500 leading-relaxed">{course.description}</p>
                    </div>
                  </button>
                ))}
              </div>
            </main>
          </div>
            </>
          )}
        </div>
      </div>

      {showUpgradeModal && (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-zinc-950/60 px-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="upgrade-required-title"
        >
          <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
            <h2 id="upgrade-required-title" className="text-2xl font-black text-zinc-950">
              Upgrade Required
            </h2>
            <p className="mt-4 text-sm font-medium leading-6 text-zinc-600">
              This content is not in your current plan. Please upgrade your plan to access it.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
              <button
                type="button"
                onClick={() => setShowUpgradeModal(false)}
                className="rounded-xl border border-zinc-200 px-5 py-3 text-sm font-black uppercase tracking-widest text-zinc-700 transition-colors hover:bg-zinc-50"
              >
                Not now
              </button>
              <button
                type="button"
                onClick={() => navigate('/pricing/')}
                className="rounded-xl bg-[#09090B] px-5 py-3 text-sm font-black uppercase tracking-widest text-white transition-colors hover:bg-zinc-800"
              >
                Upgrade Plan
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Library;
